<section class="auction-vehicle-details">
  <div class="container-fluid">
    <div class="card auction-content-main m-0">
      <div class="auction-content-body position-relative p-4 pt-5">
        <span
          *ngIf="vehicleInfo['type']"
          class="
            auction-vehicle-details__badge
            auction-vehicle-details__badge--yellow
          "
        >
          {{ tags[vehicleInfo["type"]]["tagName"] }}
        </span>
        <div class="auction-vehicle-details__basicInfoWrapper row mx-0 mb-4">
          <div class="col-md-7">
            <div class="">
              <app-item-slider [slides]="slides"></app-item-slider>
            </div>
          </div>
          <div class="col-md-5">
            <div class="px-md-3">
              <div class="auction-vehicle-details__title mb-4">
                <h3 class="heading-tertiary">{{ vehicleName }}</h3>
              </div>
              <div class="auction-vehicle-details__infos mb-4">
                <div class="info-row">
                  <h4 class="fs-sm color-ashen-med mb-0" *ngIf="location">
                    Location
                  </h4>
                  {{ location }}
                </div>
              </div>

              <!-- start -->
              <div class="d-flex flex-column gap-4">
                <div
                  class="d-flex align-items-center justify-content-between mb-4"
                  *ngIf="
                    vehicleInfo['type'] === '2' ||
                    vehicleInfo['type'] === '3' ||
                    vehicleInfo['type'] === '4'
                  "
                >
                  <p class="m-0 mr-2">
                    Vehicle Status:
                    <span class="font-weight-bold">{{
                      vehicleStatus ? "Active" : "Inactive"
                    }}</span>
                  </p>
                  <button
                    type="button"
                    [ladda]="laddaLoading"
                    class="btn btn__main curved green px-4 mr-2"
                    *ngIf="!vehicleStatus"
                    (click)="updateVehicleStatus(productId, !vehicleStatus)"
                  >
                    Active
                  </button>

                  <button
                    type="button"
                    [ladda]="laddaLoading"
                    class="btn btn__main curved red px-4"
                    *ngIf="vehicleStatus"
                    (click)="updateVehicleStatus(productId, !vehicleStatus)"
                  >
                    Inactive
                  </button>
                </div>

                <div
                  class="d-flex align-items-center justify-content-between"
                  *ngIf="vehicleInfo['type'] !== '4'"
                >
                  <p class="m-0 mr-2">
                    Vehicle Buy Status:
                    <span class="font-weight-bold text-capitalize">{{
                      vehicleBuyStatus
                    }}</span>
                  </p>
                  <button
                    type="button"
                    class="btn btn__main btn-main curved px-4 mr-2"
                    (click)="toggleSold()"
                    [disabled]="vehicleBuyStatus === 'sold'"
                  >
                    Sold
                  </button>
                </div>
              </div>
              <!-- end -->
            </div>
          </div>
        </div>

        <div class="auction-vehicle-details__specification bg-sky-l mb-4 p-3">
          <div class="row">
            <div
              class="col-md-6 col-lg-4 py-2"
              *ngFor="let info of vehicleInfo['description_data'] | keyvalue"
            >
              <ul class="specification-list list-unstyled mb-4 mb-lg-0">
                <li class="specification-list__item">
                  <span
                    *ngIf="
                      info.key === 'Test Drive Video' ||
                        info.key === 'Vehicle 360 Link';
                      else otherAttributes
                    "
                    class="d-flex specification-list__heading"
                  >
                    <ng-container *ngIf="info.key === 'Vehicle 360 Link'">
                      Vehicle 360&deg; Link:
                      <button
                        type="button"
                        class="test_drive"
                        (click)="open360ViewModal(modalTemplate, info.value)"
                      >
                        View
                      </button>
                    </ng-container>
                    <ng-container *ngIf="info.key === 'Test Drive Video'">
                      Test Drive Video:
                      <button
                        type="button"
                        class="test_drive"
                        (click)="openTestDriveModal(modalTemplate, info.value)"
                      >
                        View
                      </button>
                    </ng-container>
                  </span>
                  <ng-template #otherAttributes>
                    <span class="specification-list__heading">{{
                      info.key + ":"
                    }}</span>
                    {{ info.value }}
                  </ng-template>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- start -->
        <div
          *ngIf="vehicleOtherInfo.length"
          class="auction-vehicle-details__specification bg-sky-l mb-4 p-3"
        >
          <div class="row">
            <div
              class="col-md-6 col-lg-4 py-2"
              *ngFor="let info of vehicleOtherInfo"
            >
              <ul class="specification-list list-unstyled mb-4 mb-lg-0">
                <li class="specification-list__item">
                  <span class="specification-list__heading">{{
                    Object.keys(info)[0] + ":"
                  }}</span>
                  {{ Object.values(info)[0] }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- end -->
      </div>
    </div>
  </div>
</section>
<app-loader *ngIf="loading"></app-loader>

<ng-template #modalTemplate>
  <div class="modal-header">
    <ng-container *ngIf="switch === 'testDrive'">
      <h4 class="modal-title pull-left">{{ vehicleName }} Test Drive Video</h4>
    </ng-container>
    <ng-container *ngIf="switch === '360View'">
      <h4 class="modal-title pull-left">{{ vehicleName }} 360&deg; View</h4>
    </ng-container>
    <button
      type="button"
      class="btn-close close pull-right"
      aria-label="Close"
      (click)="modalRef?.hide()"
    >
      <span aria-hidden="true" class="visually-hidden"
        ><ion-icon name="close-outline"></ion-icon
      ></span>
    </button>
  </div>
  <div class="modal-body">
    <iframe
      id="spins-data"
      style="width: -webkit-fill-available; min-height: 60vh; border: none"
    ></iframe>
  </div>
</ng-template>

<app-confirm-sold-modal
  [isOpen]="showConfirm"
  [actionMessage]="'Do you want to mark these vehicle as sold?'"
  [actionInProgress]="deleting"
  [autoConfirmSeconds]="10"
  [fromVehicle]="true"
  [confirmLable]="'Mark as Sold'"
  (confirmed)="onConfirmed()"
  (cancelled)="onCancelled()"
></app-confirm-sold-modal>
